/** Keep native product forms, but make variant and submission state explicit. */
class RetailProduct extends HTMLElement {
  #form;
  #variants = [];
  #pending = false;
  #timer;

  connectedCallback() {
    this.#form = this.querySelector('form');
    if (!this.#form) return;
    try {
      this.#variants = JSON.parse(this.querySelector('[data-retail-variants]')?.textContent || '[]');
    } catch { return; }
    this.#form.addEventListener('change', this.#onChange);
    this.#form.addEventListener('submit', this.#onSubmit);
    window.addEventListener('pageshow', this.#restore);
    this.#sync();
  }

  disconnectedCallback() {
    clearTimeout(this.#timer);
    this.#form?.removeEventListener('change', this.#onChange);
    this.#form?.removeEventListener('submit', this.#onSubmit);
    window.removeEventListener('pageshow', this.#restore);
  }

  get #selected() {
    const id = this.#form?.querySelector('[name="id"]:checked, input[type="hidden"][name="id"]')?.value;
    return this.#variants.find(variant => String(variant.id) === id);
  }

  get #buttons() {
    return [this.#form?.querySelector('[type="submit"]'), document.querySelector(`[form="${this.#form?.id}"][type="submit"]`)].filter(Boolean);
  }

  #sync() {
    const variant = this.#selected;
    if (!variant) return;
    const price = this.closest('.tt-buycol')?.querySelector('[data-variant-price]');
    if (price) price.textContent = variant.price;
    const stock = this.querySelector('[data-retail-stock]');
    if (stock) stock.hidden = !variant.available;
    const unavailable = this.querySelector('[data-retail-unavailable]');
    if (unavailable) unavailable.hidden = variant.available;
    const stickyPrice = document.querySelector(`[data-retail-sticky-price][data-retail-form="${this.#form.id}"]`);
    if (stickyPrice) stickyPrice.textContent = variant.price;
    for (const summaryPrice of document.querySelectorAll(`[data-retail-price-for="${this.#form.id}"]`)) {
      summaryPrice.textContent = variant.price;
    }
    const compare = this.closest('.tt-buycol')?.querySelector('[data-retail-compare]');
    if (compare) {
      compare.hidden = !variant.compare;
      compare.textContent = variant.compare || '';
    }
    for (const button of this.#buttons) {
      button.disabled = this.#pending || !variant.available;
      button.textContent = this.#pending ? this.dataset.labelAdding : variant.available ? this.dataset.labelAdd : this.dataset.labelSoldOut;
    }
  }

  #onChange = (event) => {
    if (event.target.name !== 'id') return;
    this.#sync();
    const variant = this.#selected;
    if (variant) {
      const url = new URL(window.location.href);
      url.searchParams.set('variant', String(variant.id));
      window.history.replaceState(window.history.state, '', url.pathname + url.search + url.hash);
    }
  };

  #onSubmit = (event) => {
    if (this.#pending || !this.#selected?.available) {
      event.preventDefault();
      return;
    }
    this.#pending = true;
    this.#form.setAttribute('aria-busy', 'true');
    this.#sync();
    // Native cart navigation can be interrupted by a challenge or network error.
    this.#timer = setTimeout(this.#restore, 15000);
  };

  #restore = () => {
    clearTimeout(this.#timer);
    this.#pending = false;
    this.#form?.removeAttribute('aria-busy');
    this.#sync();
  };
}

if (!customElements.get('tt-retail-product')) customElements.define('tt-retail-product', RetailProduct);
